import { render, staticRenderFns } from "./detai-proList.vue?vue&type=template&id=28836838&scoped=true&"
import script from "./detai-proList.vue?vue&type=script&lang=js&"
export * from "./detai-proList.vue?vue&type=script&lang=js&"
import style0 from "./detai-proList.vue?vue&type=style&index=0&id=28836838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28836838",
  null
  
)

export default component.exports